export var UpdateAccountTypeIA = function UpdateAccountTypeIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_ACCOUNT_TYPE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize), FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), ONCE_WE_RECEIVE_THIS_INFO(strictLocalize)];
    }
  };
};
var UPDATE_ACCOUNT_TYPE = function UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "QzoC6y",
    defaultMessage: [{
      "type": 0,
      "value": "Atualizar o tipo de conta para \"Loja física\""
    }]
  });
};
var PLEASE_SEND_US_THE_FOLLOWING_INFO = function PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize) {
  return strictLocalize({
    id: "oR9T2X",
    defaultMessage: [{
      "type": 0,
      "value": "Para começar, envie-nos as seguintes informações através das opções de contacto fornecidas na secção \"Contacte-nos\":"
    }]
  });
};
var FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE = function FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "rAF0hs",
    defaultMessage: [{
      "type": 0,
      "value": "1. A morada da sua loja física"
    }]
  });
};
var SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE = function SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "MvxnaR",
    defaultMessage: [{
      "type": 0,
      "value": "2. Fotografias do interior e do exterior da sua loja com o sinal da loja visível nas fotografias do exterior"
    }]
  });
};
var ONCE_WE_RECEIVE_THIS_INFO = function ONCE_WE_RECEIVE_THIS_INFO(strictLocalize) {
  return strictLocalize({
    id: "ElLq0T",
    defaultMessage: [{
      "type": 0,
      "value": "Após recebermos esta informação, a nossa equipa de apoio terá todo o gosto em atualizar o seu tipo de conta ou discutir quaisquer questões que possamos ter para si."
    }]
  });
};